import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCreditTier } from "@/api/creditTiers";
import { CreditTiersQueryKeys } from "@/tanstackQuery/queries/creditTiers";

export interface UpdateCreditTierOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useUpdateCreditTier = (options?: UpdateCreditTierOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateCreditTier,
    onSuccess(data) {
      queryClient.invalidateQueries({
        queryKey: [CreditTiersQueryKeys.All],
      });
      options?.onSuccess?.(data);
    },
    onError: options?.onError,
  });
};
